export const matrixCache = {};

export const isTemp = (id) => typeof id === "string" && id.startsWith("temp-");

export const GROUP_HEADER_COLORS = [
  "#ecdcf5",  
  "#c9f5cc",  
  "#fde3cc",  
  "#c7dbea",  
  "#f3b6b6",  
  "#d3faff",  
];
export const EFFECT_ITEM_COLOR = "#bbd3fc";
export const EFFECT_GROUP_COLORS = ["#cfe2f3", "#d9ead3", "#f4cccc", "#fff2cc", "#d9d2e9"];

export const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0,0,0,0.3)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

export const modalStyle = {
  background: "#fff",
  padding: "20px",
  borderRadius: "8px",
  width: "300px",
};

export const getProjectAndEmail = () => {
  const stored = sessionStorage.getItem("selectedProject");
  const project = stored ? JSON.parse(stored) : null;
  const email = localStorage.getItem("userEmail");
  return { project, email };
};


export const causeEffectStyles = `
  .ce-table-wrapper {
    overflow: auto;
    position: relative;
    max-height: calc(100vh - 280px);
    
    margin: 10px;
    width: 98%;
  }
  .ce-matrix-table {
    border-collapse: collapse;
    table-layout: auto;
  }
  .ce-matrix-table th,
  .ce-matrix-table td {
    border: 1px solid #999;
    text-align: center;
  }
  .ce-matrix-table thead th {
    position: sticky;
    top: 0;
  }
  .ce-matrix-table thead tr:first-child th {
    top: 0;
  }
  .ce-matrix-table thead tr:nth-child(2) th {
    top: 40px;
    z-index: 3;
  }
  .ce-matrix-table .sticky-col {
    position: sticky;
    left: 0;
    z-index: 2;
    border-right: none;
    box-shadow: inset -1px 0 0 #999, inset 0 -1px 0 #999;
  }
  .ce-matrix-table thead .sticky-col {
    z-index: 10;
  }
  .cause-group-title {
    background: #EC5800;
    font-size: 14px;
    font-weight: bold;
    text-align: left;
    padding-left: 10px !important;
    border: 1px solid #999;
  }

  .corner-cell {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 10;
    width: var(--corner-w, 190px);
    min-width: var(--corner-w, 190px);
    height: var(--corner-h, 90px);
    background-color: #ffc000e8;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100' preserveAspectRatio='none'><line x1='0' y1='0' x2='100' y2='100' stroke='black' stroke-width='1'/></svg>");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding: 0 !important;
    border-right: none;
    box-shadow: inset -1px 0 0 #999, inset 0 -1px 0 #999;
  }
  .cause-group-row td.sticky-col {
    box-shadow: inset -1px 0 0 #999, inset 0 -1px 0 #999;
  }
  .corner-cell .cause-label {
    position: absolute;
    left: 25%;
    top: 65%;
    font-weight: bold;
    transform: translate(-50%, -50%);
  }
  .corner-cell .effect-label {
    position: absolute;
    right: 30%;
    top: 20%;
    font-weight: bold;
    transform: translate(50%, -50%);
  }
  .effect-group-header {
    height: 40px;
    font-weight: bold;
    font-size: 13px;
  }
  .effect-group-header .group-header-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    color: black;
  }
  .effect-col-header .vertical-text {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
    font-size: 12px;
    font-weight: normal;
    cursor: pointer;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    max-height: 180px;
  }
  .cause-group-row {
    border: 1px solid #999 !important;
    background: #e9efcc87 !important;
  }

  .cause-cell {
    min-width: 250px;
    font-size: 12px;
    text-align: left !important;
    padding-left: 10px !important;
    background: #dbe5f1;
  }
  .effect-col-header {
    width: var(--effect-col-w, 26px);
    min-width: var(--effect-col-w, 100px);
    max-width: var(--effect-col-w, 90px);
    background: inherit;
    vertical-align: bottom;
    padding-bottom: 6px !important;
  }
  .matrix-cell {
    width: var(--effect-col-w, 26px);
    min-width: var(--effect-col-w, 26px);
    cursor: pointer;
    font-weight: bold;
    color: red;
    height: 26px;
    background:#e6eec963;
  }

  .hover-actions {
    display: flex;
    gap: 6px;
    opacity: 0;
    visibility: hidden;
    transition: opacity .2s ease;
  }
  .cause-group-title:hover .hover-actions,
  .cause-group-row:hover .hover-actions {
    opacity: 1;
    visibility: visible;
  }
  .hover-action {
    opacity: 0;
    visibility: hidden;
    transition: opacity .2s ease;
  }
  .effect-col-header:hover .hover-action,
  .cause-cell:hover .hover-action {
    opacity: 1;
    visibility: visible;
  }

  .hover-actions svg,
  .hover-action {
    cursor: pointer;
  }

  .effect-col-header .effect-trash {
    margin-top: 2px;
  }
  .cause-group-fill {
    border: 1px solid #999;
  }

  .workflow-tab-btn {
    padding: 8px 14px;
    border: none;
    background: transparent;
    cursor: pointer;
  }
`;